import { makeNumberRenderer } from 'App/data-export/valueTypeRenderers/renderers/_utils/makeNumberRenderer'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const chillCumulativeHoursBelow45FMAR: typeof valueTypeRenderers.chillCumulativeHoursBelow45FMAR = {
  label: () => unitConverter.chillCumulativeHoursBelow45FMAR().title(),
  point: () =>
    makeNumberRenderer({
      baseLabel: unitConverter.chillCumulativeHoursBelow45FMAR().title(),
      render: (n) => unitConverter.chillCumulativeHoursBelow45FMAR(n).valueAsString(),
    }),
}
